import React from 'react'
import { useEditor } from '@smartfire/js-block-engine'
import { eventCategoryTaxonomyProps } from '../../types'
import style from './style.module.scss'
import clsx from 'clsx'

type taxonomyNavigationProps = {
    terms?: eventCategoryTaxonomyProps[]
    seeMoreText?: string
    seeMoreLink?: string
    showTerms?: boolean
}

export const TaxonomyNavigation: React.FC<taxonomyNavigationProps> = ({
    terms,
    seeMoreLink,
    seeMoreText = 'Voir tout',
    showTerms = false,
}) => {
    const { isEditing } = useEditor()

    return (
        <nav className={clsx(style.nav, isEditing && style.admin)}>
            <ul>
                {showTerms &&
                    terms?.map((item) => (
                        <li key={item.term_id}>
                            <a href={item.link}>
                                <span>{item.name}</span>
                            </a>
                        </li>
                    ))}

                {seeMoreLink && (
                    <li className={style.cta}>
                        <a href={seeMoreLink}>
                            <span>{seeMoreText}</span>
                            <i className="fi-rs-arrow-right" />
                        </a>
                    </li>
                )}
            </ul>
        </nav>
    )
}
